import React from "react";
import {Edit,useRecordContext,required,FormDataConsumer,Button,FunctionField,SimpleForm,TextInput, Toolbar, ListButton,SaveButton} from "react-admin";

import { InfluencerStatusSelectInput,InfluencerRatingBasedSelectNewInput } from "../../UI/Input/SelectInput";

import Grid from "@material-ui/core/Grid";
import { useNavigate } from "react-router-dom";

const PageTitle = () => {
  const record = useRecordContext();
  return <span>Team Member New task for {record ? `${record.profile_id}` : ''}</span>;
};
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};
const FormToolbar = (props) => {
  const navigate = useNavigate();

  return (
    <Toolbar {...props}>
      <SaveButton
        label="Save"
        submitOnEnter={true}
        alwaysEnable
        mutationOptions={{
          onSuccess: () => {
            navigate('/teamleadernew');
          }
        }}
      />

      {!props.saving && (
        <Button
          label="Cancel"
          onClick={() => navigate('/teamleadernew')}
        />
      )}
    </Toolbar>
  );
};

const TeamMembersEdit = (props) => {
  
  return (
    <Edit title={<PageTitle />} {...props} undoable={false}  mutationMode="pessimistic"
  redirect={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />}  defaultValues={{ action: "full" }}>       
          <SanitizedGrid container spacing={3} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Profile ID" source="profile_id" fullWidth />
            </Grid>
            <Grid item sm={12}  lg={4}>
            <TextInput disabled label="Name" source="name" fullWidth />
            </Grid> 
            <Grid item sm={12}  lg={4}>
              <TextInput disabled label="Phone" source="phone" fullWidth />
            </Grid>
          </SanitizedGrid>

          <SanitizedGrid container spacing={3} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Email" source="email" fullWidth />
            </Grid>
            <Grid item sm={12}  lg={4}>
            <TextInput disabled label="Telegram ID" source="telegram_id" fullWidth />
            </Grid> 
            <Grid item sm={12}  lg={4}>
              <TextInput disabled label="Team Leader Profile ID" source="team_leader_profile_id" fullWidth />
            </Grid>
          </SanitizedGrid>
       
          <SanitizedGrid container spacing={3} fullWidth>
           
           
            <Grid item sm={12}  lg={4}>
           <InfluencerStatusSelectInput validate={required()} label="Status" fullWidth source="status"/>
            </Grid>     
            <Grid item sm={12}  lg={4}>
            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.status === "Reject" && (
                  <TextInput source="reject_reason"  label="Reason" fullWidth validate={required()}/>
                )
              }
            </FormDataConsumer>
           
            </Grid>       
          </SanitizedGrid>
          
      </SimpleForm>
    </Edit>
  );
};

export default TeamMembersEdit;
